import React from "react";

import { Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

export const TextCell: React.FC<{ value: string | null }> = ({ value }) => (
  <MaterialTooltip title={value ?? "-"}>
    <Typography
      noWrap
      sx={{ fontSize: 14, color: value ? "#071f35" : "#92a7bc", lineHeight: "16px", display: "block" }}
    >
      {value ?? "-"}
    </Typography>
  </MaterialTooltip>
);
